export default __webpack_public_path__ + "static/media/peter pan.26b7c02a.jpg";